module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1536x2048.1d28b396.png";